import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI_TWIN_DEMO_2 = {
  title: `With the AI-Twin for Marketer, Maya can\n<span style="color: #BEE3FF;">diagnose KPIs, receive alerts, add\ndetailed narratives</span> based on her\nobservations and seamlessly share this\nvaluable information with her team. This\nallows Maya to provide clear instructions\nand actions.`,
  subtitle: "CAMPAIGN PERFORMANCE IN REAL TIME",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(307),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(305),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_04.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "AI_TWIN/AI_TWIN_DEMO_computer.png",
          imageStyle: {
            position: "absolute",
            right: "63.62px",
            bottom: "272px",
          },
          effect: "animate-opacity",
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_2_bubble_1.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_2_bubble_2.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_2_bubble_3.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
      ]}
      pageNumber={306}
    />
  ),
};
